<template>
	<div id="address-item">
		<div v-if="type === '1'" class="icon ji-icon"></div>
		<div v-if="type === '2'" class="icon shou-icon"></div>
		<div class="info">
			<p>
				<span>{{ addressInfo.name }}</span>
				<span class="phone">{{ addressInfo.concatPhone }}</span>
			</p>
			<p>{{addressInfo.provinceName + addressInfo.cityName + addressInfo.districtName + addressInfo.clothingCityName + addressInfo.address}}</p>
			<!--            <p class="detail flex-layout">-->
			<!--                <span v-show="addressInfo.goodsNumber>0">{{addressInfo.goodsNumber}}件</span>-->
			<!--                <span v-show="addressInfo.packName!==''">{{addressInfo.packName}}</span>-->
			<!--                <span v-show="addressInfo.stc>0">{{addressInfo.stc?'需要手推车':''}}</span>-->
			<!--                <span v-show="addressInfo.planDeliveryDate!==''">{{addressInfo.planDeliveryDate}}</span>-->
			<!--            </p>-->
		</div>
		<!--        <div class="del-btn flex-layout" @click="delAddress" v-show="type==='1'">-->
		<!--            <van-icon name="delete" color="#0b92e6" size="14px"/><span>删除</span>-->
		<!--        </div>-->
		<div @click="addressBook" class="book-icon flex-layout"><span class="icon-book"></span></div>
	</div>
</template>

<script>
export default {
	name: 'SelAddressItem',
	data() {
		return {};
	},
	props: {
		type: {
			type: String,
			required: true
		},
		addressInfo: {
			type: Object,
			required: true
		},
		index: {
			type: Number
		},
		orderNumber: {
			type: String
		}
	},
	created() {},
	methods: {
		delAddress() {
			this.$store.commit({
				type: 'unselAddress',
				t: this.type,
				index: this.index
			});
		},
		addressBook() {
			if (this.orderNumber) {
				this.$router.push('/order/addresslist/' + this.type + '/' + this.orderNumber);
			} else {
				this.$router.push('/addresslist/' + this.type);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
#address-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background-color: #fff;
	.info {
		line-height: 26px;
		font-size: 14px;
		flex: 1;
		.phone {
			margin-left: 0.25rem;
			color: #999;
		}
		.detail {
			width: 80%;
			color: red;
			font-size: 10px;
		}
	}
	.del-btn {
		font-size: 14px;
		padding: 0.08rem 0.25rem;
		border: 1px solid #0b92e6;
		color: #0b92e6;
	}
	.icon {
		margin-right: 0.25rem;
		width: 0.64rem;
		height: 0.9rem;
		display: block;
		box-sizing: border-box;
		padding: 4px 8px 12px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: 100%;
		&.ji-icon {
			background-image: url(../assets/order2.png);
		}
		&.shou-icon {
			background-image: url(../assets/order1.png);
		}
	}
	.icon-book {
		display: block;
		width: 0.5rem;
		height: 0.5rem;
		background-size: 100%;
		background-repeat: no-repeat;
		border-left: 1px solid #ddd;
		padding-left: 0.25rem;
		background-origin: content-box;
		margin-left: 0.25rem;
		background-image: url(../assets/contact.png);
	}
}
.flex-layout {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
